import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import CommonApi from "../../../api/common.api";
import PopupApi from "../../../api/popup.api";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import Checkbox from "../../../component/atoms/input/checkbox";
import ImgInput from "../../../component/atoms/input/imgInput";
import MainInput from "../../../component/atoms/input/mainInput";
import Radio from "../../../component/atoms/input/radio";
import TextFormEditor from "../../../component/atoms/input/textFormEditor";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageFormCol from "../../../component/atoms/layout/detail/detailPageFormCol";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import GoBack from "../../../component/molecules/goBack";
import ImgPreview from "../../../component/molecules/imgPreview";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { imgUrl } from "../../../constants/url";
import { isNull } from "../../../util/check";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import PretendardText from "../../../component/atoms/text/pretendardText";
import DateInput from "../../../component/atoms/input/dateInput";
import LectureApi from "../../../api/lecture.api";
import { tagList } from "../../../constants/tagList";
import Basic from "./../../service/basic/basic";

const hasContent = (html) =>
  !isNull(html) &&
  (/<(img|video|iframe)\b[^>]*>/i.test(html) ||
    html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim().length > 0);

const LectureEdit = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  const [selectBoxOpen, setSelectBoxOpen] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState(-1);

  // ----- 정보 가져오기
  const [lectureInfo, setLectureInfo] = useState({
    activation: true,
    lectureCategoryType: "FINANCE_STUDY",
    title: "",
    content: "",
    price: "",
    tag: [],
    period: "",
    startDate: new Date(),
    endDate: new Date(),
    limitFlag: false,
    fileThumbnail: "",
    fileUrlThumbnail: "",
    fileInstructor: "",
    fileUrlInstructor: "",
    instructorName: "",
    instructorIntro: "",
    career: [],
  });

  useEffect(() => {
    getConsultingInfo();
  }, []);

  const getConsultingInfo = async () => {
    try {
      const response = (await LectureApi.getLectureById(id)).data.data.content;

      setLectureInfo(response);
      setSelectedCategory(response.lectureCategory.title);
      setSelectedCategoryId(response.lectureCategory.id);

      getCategory(response.lectureCategoryType);
    } catch (error) {
      errorHandler(error);
    }
  };

  // mounted
  useEffect(() => {
    getCategory();
  }, [lectureInfo.lectureCategoryType]);

  const getCategory = async (category) => {
    try {
      const data = {
        lectureCategoryType: lectureInfo.lectureCategoryType,
      };

      let responseData = (await LectureApi.getCategory(data)).data.data.content;

      setCategoryList(responseData);
    } catch (error) {
      errorHandler(error);
    }
  };

  const [career, setCareer] = useState([]);

  const changeCareer = (value, index) => {
    const copyCareer = [...lectureInfo.career];
    copyCareer[index] = value;

    setLectureInfo({ ...lectureInfo, career: copyCareer });
  };

  const delImg = (type) => {
    if (type === "thumbnail") {
      setLectureInfo((current) => ({
        ...current,
        fileThumbnail: "",
        fileUrlThumbnail: "",
        thumbnailOriginFileName: "",
        thumbnailServerFileName: "",
      }));
    } else {
      setLectureInfo((current) => ({
        ...current,
        fileInstructor: "",
        fileUrlInstructor: "",
        instructorOriginFileName: "",
        instructorServerFileName: "",
      }));
    }
  };

  //이미지 추가, 삭제
  const inputFile = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);
    setLectureInfo((current) =>
      type === "thumbnail"
        ? {
            ...current,
            fileThumbnail: file,
            fileUrlThumbnail: previewUrl,
          }
        : {
            ...current,
            fileInstructor: file,
            fileUrlInstructor: previewUrl,
          },
    );
    e.target.value = "";
  };

  //저장하기
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const [editType, setEditType] = useState("");

  const saveBtnHandler = (editType) => {
    switch (editType) {
      case "basic":
        if (selectedCategoryId === -1 || isNull(lectureInfo.price)) {
          return toast("필수사항을 모두 입력해주세요.");
        }
        break;
      case "lecture":
        if (
          selectedCategoryId === -1 ||
          isNull(lectureInfo.title?.trim()) ||
          (!lectureInfo.thumbnailOriginFileName &&
            isNull(lectureInfo.fileThumbnail)) ||
          !hasContent(lectureInfo.content) ||
          (!lectureInfo.limitFlag &&
            (isNull(lectureInfo.period) || Number(lectureInfo.period) <= 0))
        ) {
          return toast("필수사항을 모두 입력해주세요.");
        }
        break;
      case "teacher":
        if (
          (!lectureInfo.instructorOriginFileName &&
            isNull(lectureInfo.fileInstructor)) ||
          isNull(lectureInfo.instructorName?.trim()) ||
          isNull(lectureInfo.instructorIntro?.trim()) ||
          !lectureInfo.career?.some((item) => item?.trim())
        ) {
          return toast("필수사항을 모두 입력해주세요.");
        }
        break;
      default:
        console.error("알 수 없는 editType:", editType);
    }

    setSaveModalOpen(true);
  };

  const saveFunc = async () => {
    try {
      let data = {};

      if (editType === "basic") {
        data.activation = lectureInfo.activation;
        data.lectureCategoryId = selectedCategoryId;
        data.lectureCategoryType = lectureInfo.lectureCategoryType;
        data.tag =
          lectureInfo.lectureCategoryType === "FINANCE_STUDY"
            ? []
            : lectureInfo.tag;
        data.price =
          lectureInfo.lectureCategoryType === "FINANCE_STUDY"
            ? 0
            : lectureInfo.price;
      }

      if (editType === "lecture") {
        data.title = lectureInfo.title;
        data.period = lectureInfo.limitFlag ? 0 : Number(lectureInfo.period);
        data.limitFlag = lectureInfo.limitFlag;
        data.startDate = lectureInfo.startDate;
        data.endDate = lectureInfo.endDate;
        data.content = lectureInfo.content;
        data.thumbnailOriginFileName = lectureInfo.thumbnailOriginFileName;
        data.thumbnailServerFileName = lectureInfo.thumbnailServerFileName;

        if (!isNull(lectureInfo.fileThumbnail)) {
          const result = await fileUpload(lectureInfo.fileThumbnail);
          data.thumbnailOriginFileName = result.imageOriginFileName;
          data.thumbnailServerFileName = result.imageServerFileName;
        }
      }

      if (editType === "teacher") {
        data.instructorName = lectureInfo.instructorName;
        data.instructorIntro = lectureInfo.instructorIntro;
        data.career = lectureInfo.career
          .map((item) => item?.trim())
          .filter(Boolean);
        data.instructorOriginFileName = lectureInfo.instructorOriginFileName;
        data.instructorServerFileName = lectureInfo.instructorServerFileName;

        if (!isNull(lectureInfo.fileInstructor)) {
          const result = await fileUpload(lectureInfo.fileInstructor);
          data.instructorOriginFileName = result.imageOriginFileName;
          data.instructorServerFileName = result.imageServerFileName;
        }
      }

      await LectureApi.editLecture(id, data);
      toast(toastMsg.update);
      setSaveModalOpen(false);
      // navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 파일 업로드
  const fileUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("path", "lecture");
      formData.append("file", file);

      const response = (await CommonApi.fileUpload(formData)).data.data;

      return {
        imageOriginFileName: file.name,
        imageServerFileName: response.serverFileName,
      };
    } catch (error) {
      errorHandler(error);
      throw error;
    }
  };

  // 에디터
  const [isLoading, setIsLoading] = useState(false);

  //태그
  const changeTag = (item) => {
    if (lectureInfo.tag?.includes(item)) {
      const copyArr = [...lectureInfo.tag];
      const filteredArr = copyArr.filter((tag) => tag !== item);

      setLectureInfo({
        ...lectureInfo,
        tag: filteredArr,
      });
    } else {
      const copyArr = [...lectureInfo.tag];
      copyArr.push(item);

      setLectureInfo({
        ...lectureInfo,
        tag: copyArr,
      });
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>수정하기</DetailPageTitle>
            <DetailPageTitle>기본 설정</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>활성 상태*</DetailFormTitle>
                <div style={{ display: "flex", gap: "20px" }}>
                  <Radio
                    id={true}
                    name={"activation"}
                    valueText={"활성"}
                    checked={lectureInfo.activation}
                    onChange={() => {
                      setLectureInfo({
                        ...lectureInfo,
                        activation: true,
                      });
                    }}
                  />
                  <Radio
                    id={false}
                    name={"activation"}
                    valueText={"비활성"}
                    checked={!lectureInfo.activation}
                    onChange={() => {
                      setLectureInfo({
                        ...lectureInfo,
                        activation: false,
                      });
                    }}
                  />
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>유형*</DetailFormTitle>
                <div style={{ display: "flex", gap: "20px" }}>
                  <Radio
                    id={"FINANCE_STUDY"}
                    name={"lectureCategoryType"}
                    valueText={"금융 스터디"}
                    checked={
                      lectureInfo.lectureCategoryType === "FINANCE_STUDY"
                    }
                    onChange={() => {
                      setSelectedCategory("");
                      setSelectedCategoryId(-1);
                      setLectureInfo({
                        ...lectureInfo,
                        lectureCategoryType: "FINANCE_STUDY",
                      });
                    }}
                  />
                  <Radio
                    id={"PAID_LECTURE"}
                    name={"lectureCategoryType"}
                    valueText={"유료 강의"}
                    checked={lectureInfo.lectureCategoryType === "PAID_LECTURE"}
                    onChange={() => {
                      setSelectedCategory("");
                      setSelectedCategoryId(-1);
                      setLectureInfo({
                        ...lectureInfo,
                        lectureCategoryType: "PAID_LECTURE",
                      });
                    }}
                  />
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>카테고리*</DetailFormTitle>
                <div>
                  <div style={{ position: "relative", width: "338px" }}>
                    <SelectBoxWrapper
                      onClick={() => {
                        setSelectBoxOpen(!selectBoxOpen);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <PretendardText
                        style={{
                          color: "#262C31",
                          fontSize: "15px",
                          fontWeight: "400",
                          lineHeight: "21.25px",
                        }}
                      >
                        {selectedCategory || "카테고리를 선택해주세요."}
                      </PretendardText>
                      <img
                        src="/assets/admin/icons/ico_select_arrow_down.svg"
                        alt=""
                      />
                    </SelectBoxWrapper>
                    {selectBoxOpen ? (
                      <SubMenuWrapper>
                        {categoryList.map((item, index) => {
                          return (
                            <SubMenuTextWrapper
                              key={index}
                              onClick={() => {
                                setSelectedCategory(item.title);
                                setSelectedCategoryId(item.id);
                                setSelectBoxOpen(false);
                              }}
                            >
                              <PretendardText
                                style={{
                                  color: "#262C31",
                                  fontSize: "15px",
                                  fontWeight: "500",
                                  lineHeight: "21.5px",
                                }}
                              >
                                {item.title}
                              </PretendardText>
                              {selectedCategory === item.title ? (
                                <img
                                  src="/assets/admin/icons/ico_select_checked.svg"
                                  alt=""
                                />
                              ) : null}
                            </SubMenuTextWrapper>
                          );
                        })}
                      </SubMenuWrapper>
                    ) : null}
                  </div>
                </div>
              </DetailPageForm>
              {lectureInfo.lectureCategoryType === "PAID_LECTURE" && (
                <DetailPageForm>
                  <DetailFormTitle>태그</DetailFormTitle>
                  <div
                    style={{
                      width: "600px",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px 20px",
                    }}
                  >
                    {tagList.map((item, index) => {
                      return (
                        <CheckboxWrapper key={index}>
                          <Checkbox
                            id="alarm"
                            checked={lectureInfo.tag?.includes(item)}
                            onChange={() => {
                              changeTag(item);
                            }}
                          />
                          <DetailFormText>{item}</DetailFormText>
                        </CheckboxWrapper>
                      );
                    })}
                  </div>
                </DetailPageForm>
              )}
              <DetailPageForm>
                <DetailFormTitle>강의 금액*</DetailFormTitle>
                <MainInput
                  disabled={lectureInfo.lectureCategoryType !== "PAID_LECTURE"}
                  style={{
                    width: "338px",
                  }}
                  type={"number"}
                  placeholder={"결제 금액을 입력해주세요"}
                  value={
                    lectureInfo.lectureCategoryType !== "PAID_LECTURE"
                      ? 0
                      : lectureInfo.price
                  }
                  onChange={(e) =>
                    setLectureInfo({ ...lectureInfo, price: e.target.value })
                  }
                />
              </DetailPageForm>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                onClick={() => {
                  saveBtnHandler("basic");
                  setEditType("basic");
                }}
              />
            </div>
          </DetailPage>
          <DetailPage>
            <DetailPageTitle>강의 설정</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>강의명*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"text"}
                  placeholder={"강의명을 입력해주세요"}
                  value={lectureInfo.title}
                  onChange={(e) =>
                    setLectureInfo({ ...lectureInfo, title: e.target.value })
                  }
                />
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>수강기간*</DetailFormTitle>
                <div>
                  <div style={{ display: "flex", gap: "20px" }}>
                    <Radio
                      id={"limit"}
                      name={"period"}
                      valueText={"일자 설정"}
                      checked={!lectureInfo.limitFlag}
                      onChange={() => {
                        setLectureInfo({
                          ...lectureInfo,
                          limitFlag: false,
                        });
                      }}
                    />
                    <Radio
                      id={"free"}
                      name={"period"}
                      valueText={"무제한"}
                      checked={lectureInfo.limitFlag}
                      onChange={() => {
                        setLectureInfo({
                          ...lectureInfo,
                          limitFlag: true,
                          period: "",
                        });
                      }}
                    />
                  </div>
                  {!lectureInfo.limitFlag && (
                    <MainInput
                      style={{
                        width: "338px",
                        marginTop: "20px",
                      }}
                      type={"number"}
                      placeholder={"구매 후 수강 가능한 일수를 입력해 주세요."}
                      value={lectureInfo.period}
                      onChange={(e) =>
                        setLectureInfo({
                          ...lectureInfo,
                          period: e.target.value,
                        })
                      }
                    />
                  )}
                </div>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>
                  썸네일 이미지*
                  <br />
                  (권장사이즈 585*373)
                </DetailFormTitle>
                {lectureInfo.thumbnailServerFileName ||
                lectureInfo.fileThumbnail ? (
                  <ImgPreview
                    fileUrl={
                      lectureInfo.fileUrlThumbnail
                        ? lectureInfo.fileUrlThumbnail
                        : imgUrl + lectureInfo.thumbnailServerFileName
                    }
                    onClick={() => {
                      delImg("thumbnail");
                    }}
                    style={{ width: "150px", height: "94px" }}
                    imgStyle={{ width: "150px", height: "94px" }}
                  />
                ) : (
                  <ImgInput
                    id={"thumbnail"}
                    accept={"image/*"}
                    onChange={(e) => {
                      inputFile(e, "thumbnail");
                    }}
                    style={{ width: "150px", height: "94px" }}
                  />
                )}
              </DetailPageForm>
              <DetailPageFormCol>
                <DetailFormTitle>강의 소개*</DetailFormTitle>
                <StyledQuillContainer>
                  <TextFormEditor
                    placeholder={"내용을 입력해 주세요."}
                    value={lectureInfo.content}
                    onChange={(contents) => {
                      setLectureInfo({
                        ...lectureInfo,
                        content: contents,
                      });
                    }}
                    editorHeight={262}
                    style={{
                      width: "964px",
                      marginTop: 6,
                    }}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                  />
                </StyledQuillContainer>
              </DetailPageFormCol>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                onClick={() => {
                  saveBtnHandler("lecture");
                  setEditType("lecture");
                }}
              />
            </div>
          </DetailPage>
          <DetailPage>
            <DetailPageTitle>강사 소개</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>
                  강사 사진*
                  <br />
                  (권장사이즈 380*380)
                </DetailFormTitle>
                {lectureInfo.instructorServerFileName ||
                lectureInfo.fileUrlInstructor ? (
                  <ImgPreview
                    fileUrl={
                      lectureInfo.fileUrlInstructor
                        ? lectureInfo.fileUrlInstructor
                        : imgUrl + lectureInfo.instructorServerFileName
                    }
                    onClick={() => {
                      delImg("instructor");
                    }}
                  />
                ) : (
                  <ImgInput
                    id={"instructor"}
                    accept={"image/*"}
                    onChange={(e) => {
                      inputFile(e, "instructor");
                    }}
                  />
                )}
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>강사명*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"text"}
                  placeholder={"강사명을 입력해주세요"}
                  value={lectureInfo.instructorName}
                  onChange={(e) =>
                    setLectureInfo({
                      ...lectureInfo,
                      instructorName: e.target.value,
                    })
                  }
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>소개글*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "744px",
                  }}
                  type={"text"}
                  placeholder={"소개글을 입력해주세요"}
                  value={lectureInfo.instructorIntro}
                  onChange={(e) =>
                    setLectureInfo({
                      ...lectureInfo,
                      instructorIntro: e.target.value,
                    })
                  }
                />
              </DetailPageForm>

              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>경력사항*</DetailFormTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                    }}
                  >
                    <MainInput
                      style={{
                        width: "338px",
                      }}
                      type={"text"}
                      placeholder={"경력사항을 입력해 주세요."}
                      value={career}
                      onChange={(e) => setCareer(e.target.value)}
                    />
                    <CareerBtn
                      onClick={() => {
                        if (!career) {
                          return toast("경력사항을 입력해 주세요.");
                        }
                        setLectureInfo({
                          ...lectureInfo,
                          career: [...lectureInfo.career, career],
                        });
                        setCareer("");
                      }}
                    >
                      <PretendardText
                        style={{
                          color: "#636C73",
                          fontWeight: 600,
                          fontSize: "15px",
                        }}
                      >
                        + 추가
                      </PretendardText>
                    </CareerBtn>
                  </div>

                  {lectureInfo.career.length > 0 ? (
                    <>
                      {lectureInfo.career.map((item, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              gap: "10px",
                            }}
                          >
                            <MainInput
                              style={{
                                width: "338px",
                              }}
                              type={"text"}
                              placeholder={"경력사항을 입력해 주세요."}
                              value={item}
                              onChange={(e) =>
                                changeCareer(e.target.value, index)
                              }
                            />
                            <CareerBtn
                              onClick={() => {
                                const copyArr = [...lectureInfo.career];
                                copyArr.splice(index, 1);
                                setLectureInfo({
                                  ...lectureInfo,
                                  career: copyArr,
                                });
                              }}
                            >
                              <PretendardText
                                style={{
                                  color: "#636C73",
                                  fontWeight: 600,
                                  fontSize: "15px",
                                }}
                              >
                                - 삭제
                              </PretendardText>
                            </CareerBtn>
                          </div>
                        );
                      })}
                    </>
                  ) : null}
                </div>
              </DetailPageForm>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                onClick={() => {
                  saveBtnHandler("teacher");
                  setEditType("teacher");
                }}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={saveFunc}
        />
      ) : null}
    </>
  );
};

export default LectureEdit;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const StyledQuillContainer = styled.div`
  //.ql-editor {
  //    padding: 0;
  // }
`;

const CareerBtn = styled.div`
  height: 48px;
  border: 1px solid #dfe1e4;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  cursor: pointer;
`;

const SelectBoxWrapper = styled.div.attrs((props) => {})`
  width: 338px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 15px;
  border-radius: 4px;
  border: 1px solid #adb4ba;
  background: #fff;
`;

const SubMenuWrapper = styled.div.attrs((props) => {})`
  width: 338px;
  max-height: 200px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 4px 20px 0px rgba(10, 13, 20, 0.15);
  position: absolute;
  top: 50px;
  right: 0;
  padding: 10px;
  overflow-y: auto;
  z-index: 5;

  &::-webkit-scrollbar {
    width: 15px;
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b8c1; /* 스크롤바의 색상 */
    border-radius: 9px;
    background-clip: padding-box;
    border: 6px solid transparent;
  }

  &::-webkit-scrollbar-track {
    background: transparent; /*스크롤바 뒷 배경 색상*/
  }
`;

const SubMenuTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  padding: 10px;
  cursor: pointer;
  border-radius: 3px;

  &:hover {
    background-color: #f2f4f5;
  }
`;
